import { render } from "./FlashCardDetailsScreen.vue?vue&type=template&id=20ae083d&scoped=true"
import script from "./FlashCardDetailsScreen.vue?vue&type=script&lang=js"
export * from "./FlashCardDetailsScreen.vue?vue&type=script&lang=js"

import "./FlashCardDetailsScreen.vue?vue&type=style&index=0&id=20ae083d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ae083d"]])

export default __exports__